import { AppSetting } from "@booking/booking/api/appSetting/types";
import { StateCreator } from "zustand";

import { AppSettingState } from "./types";

const initState = {
  features: {
    loyaltyEnabled: false,
  },
};

export const createAppSettingState: StateCreator<AppSettingState> = (
  set,
  get,
) => ({
  appSetting: initState,

  appSettingActions: {
    setAppSetting: (appSetting: AppSetting) => {
      set({ appSetting });
    },
  },

  appSettingUtils: {
    getFeatureEnabled: (feature) => get().appSetting.features[feature],
  },
});
